var _toConsumableArray = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\toConsumableArray.js");

var _regeneratorRuntime = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\regenerator\\index.js");

var _asyncToGenerator = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\asyncToGenerator.js");

var _classCallCheck = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\classCallCheck.js");

var _createClass = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\createClass.js");

var _assertThisInitialized = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\assertThisInitialized.js");

var _inherits = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\inherits.js");

var _possibleConstructorReturn = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\possibleConstructorReturn.js");

var _getPrototypeOf = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EventEmitter = require('events'); // returns a chainId if it's found to be inconsistent, otherwise false


function updatePayloadChain(payload) {
  if (payload.method === 'eth_sendTransaction') {
    var tx = payload.params[0] || {};

    if ('chainId' in tx) {
      return parseInt(tx.chainId) !== parseInt(payload.chainId) && tx.chainId;
    }

    tx.chainId = payload.chainId;
  }

  return false;
}

var EthereumProvider = /*#__PURE__*/function (_EventEmitter) {
  "use strict";

  _inherits(EthereumProvider, _EventEmitter);

  var _super = _createSuper(EthereumProvider);

  function EthereumProvider(connection) {
    var _this;

    _classCallCheck(this, EthereumProvider);

    _this = _super.call(this);
    _this.enable = _this.enable.bind(_assertThisInitialized(_this));
    _this._send = _this._send.bind(_assertThisInitialized(_this));
    _this.send = _this.send.bind(_assertThisInitialized(_this));
    _this._sendBatch = _this._sendBatch.bind(_assertThisInitialized(_this));
    _this.subscribe = _this.subscribe.bind(_assertThisInitialized(_this));
    _this.unsubscribe = _this.unsubscribe.bind(_assertThisInitialized(_this));
    _this.sendAsync = _this.sendAsync.bind(_assertThisInitialized(_this));
    _this.sendAsyncBatch = _this.sendAsyncBatch.bind(_assertThisInitialized(_this));
    _this.isConnected = _this.isConnected.bind(_assertThisInitialized(_this));
    _this.close = _this.close.bind(_assertThisInitialized(_this));
    _this.request = _this.request.bind(_assertThisInitialized(_this));
    _this.connected = false;
    _this.nextId = 1;
    _this.promises = {};
    _this.subscriptions = [];
    _this.connection = connection;

    _this.connection.on('connect', function () {
      return _this.checkConnection();
    });

    _this.connection.on('close', function () {
      _this.connected = false;

      _this.emit('close');

      _this.emit('disconnect');
    });

    _this.connection.on('payload', function (payload) {
      var id = payload.id,
          method = payload.method,
          error = payload.error,
          result = payload.result;

      if (typeof id !== 'undefined') {
        if (_this.promises[id]) {
          // Fulfill promise
          var requestMethod = _this.promises[id].method;

          if (requestMethod && ['eth_accounts', 'eth_requestAccounts'].includes(requestMethod)) {
            var accounts = result || [];
            _this.accounts = accounts;
            _this.selectedAddress = accounts[0];
            _this.coinbase = accounts[0];
          }

          payload.error ? _this.promises[id].reject(error) : _this.promises[id].resolve(result);
          delete _this.promises[id];
        }
      } else if (method && method.indexOf('_subscription') > -1) {
        // Emit subscription result
        // Events: connect, disconnect, chainChanged, chainsChanged, accountsChanged, assetsChanged, message
        _this.emit(payload.params.subscription, payload.params.result);

        _this.emit(method, payload.params); // Older EIP-1193


        _this.emit('message', {
          // Latest EIP-1193
          type: payload.method,
          data: {
            subscription: payload.params.subscription,
            result: payload.params.result
          }
        });

        _this.emit('data', payload); // Backwards Compatibility

      }
    });

    _this.on('newListener', function (event) {
      if (Object.keys(_this.eventHandlers).includes(event)) {
        if (!_this._attemptedSubscription(event) && _this.connected) {
          _this.startSubscription(event);

          if (event === 'networkChanged') {
            console.warn('The networkChanged event is being deprecated, use chainChanged instead');
          }
        }
      }
    });

    _this.eventHandlers = {
      networkChanged: function networkChanged(netId) {
        _this.networkVersion = typeof netId === 'string' ? parseInt(netId) : netId;

        _this.emit('networkChanged', _this.networkVersion);
      },
      chainChanged: function chainChanged(chainId) {
        _this.providerChainId = chainId;

        if (!_this.manualChainId) {
          _this.emit('chainChanged', chainId);
        }
      },
      chainsChanged: function chainsChanged(chains) {
        _this.emit('chainsChanged', chains);
      },
      accountsChanged: function accountsChanged(accounts) {
        _this.selectedAddress = accounts[0];

        _this.emit('accountsChanged', accounts);
      },
      assetsChanged: function assetsChanged(assets) {
        _this.emit('assetsChanged', assets);
      }
    };
    return _this;
  }

  _createClass(EthereumProvider, [{
    key: "chainId",
    get: function get() {
      return this.manualChainId || this.providerChainId;
    }
  }, {
    key: "checkConnection",
    value: function () {
      var _checkConnection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(retry) {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.checkConnectionRunning || this.connected)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                this.checkConnectionRunning = true;
                _context.prev = 3;
                _context.next = 6;
                return this._send('net_version', [], undefined, false);

              case 6:
                this.networkVersion = _context.sent;
                _context.next = 9;
                return this._send('eth_chainId', [], undefined, false);

              case 9:
                this.providerChainId = _context.sent;
                this.checkConnectionRunning = false;
                this.connected = true;
                this.emit('connect', {
                  chainId: this.providerChainId
                });
                clearTimeout(this.checkConnectionTimer);
                Object.keys(this.eventHandlers).forEach(function (event) {
                  if (_this2.listenerCount(event) && !_this2._attemptedSubscription(event)) _this2.startSubscription(event);
                });
                _context.next = 23;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](3);
                if (!retry) setTimeout(function () {
                  return _this2.checkConnection(true);
                }, 1000);
                this.checkConnectionTimer = setInterval(function () {
                  return _this2.checkConnection(true);
                }, 4000);
                this.checkConnectionRunning = false;
                this.connected = false;

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 17]]);
      }));

      function checkConnection(_x) {
        return _checkConnection.apply(this, arguments);
      }

      return checkConnection;
    }()
  }, {
    key: "_attemptedSubscription",
    value: function _attemptedSubscription(event) {
      return this["attempted".concat(event, "Subscription")];
    }
  }, {
    key: "_setSubscriptionAttempted",
    value: function _setSubscriptionAttempted(event) {
      this["attempted".concat(event, "Subscription")] = true;
    }
  }, {
    key: "startSubscription",
    value: function () {
      var _startSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(event) {
        var eventId;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.debug("starting subscription for ".concat(event, " events"));

                this._setSubscriptionAttempted(event);

                _context2.prev = 2;
                _context2.next = 5;
                return this.subscribe('eth_subscribe', event);

              case 5:
                eventId = _context2.sent;
                this.on(eventId, this.eventHandlers[event]);
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](2);
                console.warn("Unable to subscribe to ".concat(event), _context2.t0);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 9]]);
      }));

      function startSubscription(_x2) {
        return _startSubscription.apply(this, arguments);
      }

      return startSubscription;
    }()
  }, {
    key: "enable",
    value: function enable() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        _this3._send('eth_accounts').then(function (accounts) {
          if (accounts.length > 0) {
            _this3.accounts = accounts;
            _this3.selectedAddress = accounts[0];
            _this3.coinbase = accounts[0];

            _this3.emit('enable');

            resolve(accounts);
          } else {
            var err = new Error('User Denied Full Provider');
            err.code = 4001;
            reject(err);
          }
        }).catch(reject);
      });
    }
  }, {
    key: "_send",
    value: function _send(method) {
      var _this4 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var targetChain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.manualChainId;
      var waitForConnection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

      var sendFn = function sendFn(resolve, reject) {
        var payload;

        if (typeof method === 'object' && method !== null) {
          payload = method;
          payload.params = payload.params || [];
          payload.jsonrpc = '2.0';
          payload.id = _this4.nextId++;
        } else {
          payload = {
            jsonrpc: '2.0',
            id: _this4.nextId++,
            method: method,
            params: params
          };
        }

        if (!payload.method || typeof payload.method !== 'string') {
          return reject(new Error('Method is not a valid string.'));
        }

        if (targetChain) {
          if (!('chainId' in payload)) payload.chainId = targetChain;
          var mismatchedChain = updatePayloadChain(payload);

          if (mismatchedChain) {
            return reject(new Error("Payload chainId (".concat(mismatchedChain, ") inconsistent with specified target chainId: ").concat(targetChain)));
          }
        }

        _this4.promises[payload.id] = {
          resolve: resolve,
          reject: reject,
          method: method
        };

        _this4.connection.send(payload);
      };

      if (this.connected || !waitForConnection) {
        return new Promise(sendFn);
      }

      return new Promise(function (resolve, reject) {
        var resolveSend = function resolveSend() {
          clearTimeout(disconnectTimer);
          return resolve(new Promise(sendFn));
        };

        var disconnectTimer = setTimeout(function () {
          _this4.off('connect', resolveSend);

          reject(new Error('Not connected'));
        }, 5000);

        _this4.once('connect', resolveSend);
      });
    }
  }, {
    key: "send",
    value: function send(methodOrPayload, callbackOrArgs) {
      // Send can be clobbered, proxy sendPromise for backwards compatibility
      if (typeof methodOrPayload === 'string' && (!callbackOrArgs || Array.isArray(callbackOrArgs))) {
        return this._send(methodOrPayload, callbackOrArgs);
      }

      if (methodOrPayload && typeof methodOrPayload === 'object' && typeof callbackOrArgs === 'function') {
        // a callback was passed to send(), forward everything to sendAsync()
        return this.sendAsync(methodOrPayload, callbackOrArgs);
      }

      return this.request(methodOrPayload);
    }
  }, {
    key: "_sendBatch",
    value: function _sendBatch(requests) {
      var _this5 = this;

      return Promise.all(requests.map(function (payload) {
        return _this5._send(payload.method, payload.params);
      }));
    }
  }, {
    key: "subscribe",
    value: function subscribe(type, method) {
      var _this6 = this;

      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      return this._send(type, [method].concat(_toConsumableArray(params))).then(function (id) {
        _this6.subscriptions.push(id);

        return id;
      });
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(type, id) {
      var _this7 = this;

      return this._send(type, [id]).then(function (success) {
        if (success) {
          _this7.subscriptions = _this7.subscriptions.filter(function (_id) {
            return _id !== id;
          }); // Remove subscription

          _this7.removeAllListeners(id); // Remove listeners


          return success;
        }
      });
    }
  }, {
    key: "sendAsync",
    value: function sendAsync(payload, cb) {
      // Backwards Compatibility
      if (!cb || typeof cb !== 'function') return cb(new Error('Invalid or undefined callback provided to sendAsync'));
      if (!payload) return cb(new Error('Invalid Payload')); // sendAsync can be called with an array for batch requests used by web3.js 0.x
      // this is not part of EIP-1193's backwards compatibility but we still want to support it

      payload.jsonrpc = '2.0';

      if (Array.isArray(payload)) {
        return this.sendAsyncBatch(payload, cb);
      } else {
        return this._send(payload.method, payload.params).then(function (result) {
          cb(null, {
            id: payload.id,
            jsonrpc: payload.jsonrpc,
            result: result
          });
        }).catch(function (err) {
          cb(err);
        });
      }
    }
  }, {
    key: "sendAsyncBatch",
    value: function sendAsyncBatch(payload, cb) {
      return this._sendBatch(payload).then(function (results) {
        var result = results.map(function (entry, index) {
          return {
            id: payload[index].id,
            jsonrpc: payload[index].jsonrpc,
            result: entry
          };
        });
        cb(null, result);
      }).catch(function (err) {
        cb(err);
      });
    } // _sendSync (payload) {
    //   let result
    //   switch (payload.method) {
    //     case 'eth_accounts':
    //       result = this.selectedAddress ? [this.selectedAddress] : []
    //       break
    //     case 'eth_coinbase':
    //       result = this.selectedAddress || null
    //       break
    //     case 'eth_uninstallFilter':
    //       this._send(payload)
    //       result = true
    //     case 'net_version':
    //       result = this.networkVersion || null
    //       break
    //     default:
    //       throw new Error(`unsupported method ${payload.method}`)
    //   }
    //   return {
    //     id: payload.id,
    //     jsonrpc: payload.jsonrpc,
    //     result
    //   }
    // }

  }, {
    key: "isConnected",
    value: function isConnected() {
      // Backwards Compatibility
      return this.connected;
    }
  }, {
    key: "close",
    value: function close() {
      var _this8 = this;

      if (this.connection && this.connection.close) this.connection.close();
      this.connected = false;
      var error = new Error('Provider closed, subscription lost, please subscribe again.');
      this.subscriptions.forEach(function (id) {
        return _this8.emit(id, error);
      }); // Send Error objects to any open subscriptions

      this.subscriptions = []; // Clear subscriptions

      this.manualChainId = undefined;
      this.providerChainId = undefined;
      this.networkVersion = undefined;
      this.selectedAddress = undefined;
    }
  }, {
    key: "request",
    value: function request(payload) {
      return this._send(payload.method, payload.params, payload.chainId);
    }
  }, {
    key: "setChain",
    value: function setChain(chainId) {
      if (typeof chainId === 'number') chainId = '0x' + chainId.toString(16);
      var chainChanged = chainId !== this.chainId;
      this.manualChainId = chainId;

      if (chainChanged) {
        this.emit('chainChanged', this.chainId);
      }
    }
  }]);

  return EthereumProvider;
}(EventEmitter);

module.exports = EthereumProvider;